import * as $ from "jquery";

import FixedHeader from "./components/fixed-header";
import StickyHeader from "./components/sticky-header";
import TouchMenu from "./components/touch-menu";

import Sliders from "./components/sliders";

$(document).ready(() => {
	// Look for sliders, probably just on the front page for now
	const sliders = new Sliders();

	// Look for touch menus
	const menu = TouchMenu.searchAndLoadOne();

	// Look for fixed header elements
	FixedHeader.searchAndLoad()
		.forEach(header => {
			header.watch();

			const toggleEl = header.element.querySelector(`[data-action="toggle-touch-menu"]`);

			if (toggleEl) {
				toggleEl.addEventListener("click", () => {
					menu.toggle();
				});
			}
		});
});